// extracted by mini-css-extract-plugin
module.exports = {"label":"FloatingLabel_label__4O-Vs","move":"FloatingLabel_move__1DTK3","container":"FloatingLabel_container__Nbrlw"};